
import { SFConstants } from "../../../constants/SFConstants";
import { ErrorCodes } from "../../../constants/shared/ErrorCodes";
import { Poker2AchievementStatsEvent } from "../../../event/Poker2AchievementStatsEvent";
import { Poker2Model } from "../../../model/Poker2Model";
import { Poker2ProfilDialog } from "../../../view/dialogs/Poker2ProfilDialog";
import { Poker2ProfilDialogProperties } from "../../../view/dialogs/Poker2ProfilDialogProperties";
import { Poker2LayoutManager } from "../../../view/Poker2LayoutManager";
import { Poker2Command } from "../Poker2Command";

export class GPPCommand extends Poker2Command {
    protected get cmdId(): string {
        return "gpp";
    }
    public executeCommand(error: number, params: any[]): boolean {
        if (error == 0) {
            var paramObj: any = JSON.parse(params[1]);
            if (this.layoutManager.currentState != 10 && paramObj.playerId == Poker2Model.userData.playerID) {
                this.layoutManager.state = 19;
                this.controller.dispatchEvent(new Poker2AchievementStatsEvent("changeTabStatistics", [new Poker2ProfilDialogProperties(2, -1, paramObj)]));
            }
            else {
                this.layoutManager.showDialog("Poker2ProfilDialog", new Poker2ProfilDialogProperties(2, -1, paramObj));
            }
            return true;
        }
        else
            return super.executeCommand(error, params);
    }

    /**
    * TRANSPILER GENERATED FUNCTION: If a overriding getter is defined, the setter must be defined as well. WARNING: the defining class was not found, so the parentclass was assumed. Please check if this call is correct.
    **/
    protected set cmdId(value/*:String*/)/*:void*/ {
        Object.getOwnPropertyDescriptor(Poker2Command.prototype, "cmdId").set.call(this, value);
    }
}
